
const makeHappyTexts = {
  'burgers': 'Want fries, chips, and drinks with that? No problem. And no matter the dietary restrictions, we’ll make sure every taste bud at the party is satisfied. Choose from thousands of cuisine options and let guests customize individual orders during your event.',
  'tacos': 'Tacos are one of the most diverse cuisines in the world. From traditional Mexican to Asian Fusion, there are options for vegetarians, vegans, and meat lovers alike. Choose from thousands of cuisine options and let guests customize individual orders during your event. No matter the dietary requirements, every taste bud will be satisfied.',
  'ice-cream': 'Ice cream makes any event a lot more fun and delicious. Rent an ice cream truck for your party to cool off your guests. We guarantee every taste bud will be satisfied.',
  'bbq': 'BBQ takes any event to a whole new level. Let our mobile caterers prepare the entire meal before your very eyes. We guarantee every taste bud at the party will be satisfied.',
  'pizza': 'There’s nothing like a hot, fresh pie coming straight out of the oven. And whether you need vegetarian and gluten-free options, every taste bud will be satisfied. Choose from thousands of cuisine options and let guests customize individual orders during your event.',
  'default': 'This is a placeholder. There\'s nothing like food from a truck! Yum it is great',
}

const relaxEnjoyTexts = {
  'burgers': 'Book your event with confidence knowing we have established relationships with our burger trucks. We hold all funds until after your event, so we can guarantee you’ll get fantastic service every time.',
  'tacos': 'Book your event with confidence knowing we have established relationships with our taco trucks. We hold all funds until after your event, so we can guarantee you’ll get fantastic service every time.',
  'ice-cream': 'Book your event with confidence knowing we have established relationships with our ice cream truck caterers. We hold all funds until after your event, so we can guarantee you’ll get fantastic service every time.',
  'bbq': 'Book your event with confidence knowing we have established relationships with our BBQ trucks. We hold all funds until after your event, so we can guarantee you’ll get fantastic service every time.',
  'pizza': 'Book your event with confidence knowing we have established relationships with our pizza trucks. We hold all funds until after your event, so we can guarantee you’ll get fantastic service every time.',
  'default': 'Book your event with confidence knowing we have established relationships with our food trucks. We hold all funds until after your event, so we can guarantee you’ll get fantastic service every time.',
}

const repeatRepeatTexts = {
  'burgers': 'Whether for a special celebration or every week, Roaming Hunger makes it simple to book another caterer (burgers or otherwise) and feed your crowd. Being the host with the most has never been easier.',
  'tacos': 'Want to launch a Taco Tuesday lunch program? Whether for a special celebration or every week, Roaming Hunger makes it simple to book another caterer and feed your crowd. Being the host with the most has never been easier.',
  'ice-cream': 'Whether for a special celebration or every week, Roaming Hunger makes it simple to book another caterer (ice cream or otherwise) and feed your crowd. Being the host with the most has never been easier.',
  'bbq': 'Whether for a special celebration or every week, Roaming Hunger makes it simple to book another caterer (BBQ or otherwise) and feed your crowd. Being the host with the most has never been easier.',
  'pizza': ' Whether for a special celebration or every week, Roaming Hunger makes it simple to book another caterer (pizza or otherwise) and feed your crowd. Being the host with the most has never been easier.',
  'default': 'Whether for a special celebration or every week, Roaming Hunger makes it simple to book another caterer and feed your crowd. Being the host with the most has never been easier.',
}

const sectionFontColors = {
  'tacos': [
    'text-white text-lg',
    'text-black text-lg',
    'text-white text-lg',
    'text-white text-lg',
  ],
  'ice-cream': [
    'text-white text-lg',
    'text-black text-lg',
    'text-black text-lg',
    'text-white text-lg',
  ],
  'burgers': [
    'text-white text-lg',
    'text-white text-lg',
    'text-black text-lg',
    'text-white text-lg',
  ],
  'bbq': [
    'text-white text-lg',
    'text-black text-lg',
    'text-black text-lg',
    'text-white text-lg',
  ],
  'pizza': [
    'text-white text-lg',
    'text-black text-lg',
    'text-white text-lg',
    'text-black text-lg',
  ],
  'default': [
    'text-black text-lg',
    'text-black text-lg',
    'text-black text-lg',
    'text-black text-lg',
  ],
}

const faqTexts = {
  'burgers': [
    'A safe estimate is $15-25 per person, with a minimum headcount of 100 eaters for every 2 hours of catering.',
    'If you have less than 100 eaters, that’s ok, but you can expect the per person cost to increase. On average the minimum cost for taco truck catering is $1,500-$2,500.'
  ],
  'tacos': [
    'On average the minimum cost for taco truck catering is $1,000-$1,500. A good price per person estimate is $10-15 per person, with a minimum headcount of 100 eaters for every 2 hours of catering.',
    'If you have less than 100 eaters, that’s ok, but you can expect the per person cost to increase.',
    'Adding drinks or dessert options (with a savory food truck) will increase the price per person by $1-$5.',
    'If you\'re having a smaller corporate event of 50 guests or less, you\'ll probably be affected by the food truck catering minimums, and the price per person will increase.',
    'Typical service times are 2-3 hours. Additional hours will increase total costs. Travel fees can also affect pricing. Food trucks may charge a per-mile fee if your event is outside their normal travel radius (20-30 miles).',
  ],  
  'ice-cream': [
    'A safe estimate is $8-20 per person, with a minimum headcount of 100 eaters for every 2 hours of catering.',
    'If you have less than 100 eaters, that’s ok, but you can expect the per person cost to increase. On average the minimum cost for ice cream truck catering is $300-$600.',
  ],
  'bbq': [
    'A safe estimate is $15-25 per person, with a minimum headcount of 100 eaters for every 2 hours of catering.',
    'If you have less than 100 eaters, that’s ok, but you can expect the per person cost to increase. On average the minimum cost for taco truck catering is $1,500-$2,500.',
  ],
  'pizza': [
    'A safe estimate is $15-25 per person, with a minimum headcount of 100 eaters for every 2 hours of catering.',
    'If you have less than 100 eaters, that’s ok, but you can expect the per person cost to increase. On average the minimum cost for taco truck catering is $1,500-$2,500.',
  ],
  'default': (city) => [
    `The average price range for renting a food truck for catering in ${city} is between $800-$2,500.`,
    'You can also use our Food Truck Catering Cost Calculator(see above) to see starting prices in your area (although it will not be cuisine specific).',
    'Prices will vary depending on cuisine, and dessert and beverage food trucks will be less expensive than savory food trucks.',
    'Adding drinks or dessert options (with a savory food truck) will increase the price per person by $1-$5.',
    'If you\'re having a smaller corporate event of 50 guests or less, you\'ll probably be affected by the food truck catering minimums, and the price per person will increase.',
    'Typical service times are 2-3 hours. Additional hours will increase total costs. Travel fees can also affect pricing. Food trucks may charge a per-mile fee if your event is outside their normal travel radius (20-30 miles).'
  ],
}

export const getFaqTexts = (slug, city) => {
  const texts = faqTexts[slug]
  if(!texts) return faqTexts.default(city)
  return texts
}

const customTexts = {
  'makeHappy': makeHappyTexts,
  'relaxEnjoy': relaxEnjoyTexts,
  'repeatRepeat': repeatRepeatTexts,
  'faq': faqTexts,
}


export const getCustomText = (type, slug) => {
  const texts = customTexts[type]
  if (!texts) return ""
  const result = texts[slug]
  if (!result) return texts.default
  return result
}

export const getSectionFontColors = (slug) => {
  const fonts = sectionFontColors[slug]
  if (!fonts) return sectionFontColors.default
  return fonts
}

export const findImage = (images, type) => {
  const image = images.find((image) => type === image.type)
  return (image) ? image.url : null
}


export const shouldShowExtraSections = (slug) => Object.keys(makeHappyTexts).includes(slug)

export const getPrecedingArticle = (slug) => ('aeiou'.includes(slug[0])) ? 'an' : 'a'
